import styled from 'styled-components';
import { typography } from 'dab-component-lib';
import { MediaStyle, basic, GridRowStyle, GridColStyle } from '../../utils/style-utils';

export const ProductRowStyle = GridRowStyle.extend`
  flex-direction: column;
  display: block;
  ${ MediaStyle.md`
    display: flex;
    flex-direction: row;
    flew-wrap: nowrap;
  ` }
`;

export const ProductColStyle = GridColStyle.extend`
  width: 100%;
  ${ MediaStyle.md`
    width: ${props => props.quarter ? 'calc(33% - 10px)' : 'auto'};
    margin: ${props => props.quarter ? '0 15px 0 0' : '0 0 0 15px'};
    flex: ${props => props.quarter && 'none'};
    flex-grow: ${props => props.quarter ? '0' : '1'};
    flex-shrink: ${props => props.quarter ? '0' : '1'};
    flex-basis:${props => props.quarter ? '1' : '0'};
  ` }

  ${ MediaStyle.xl`
    margin: ${props => props.quarter ? '0 25px 0 10px' : '0 10px 0 25px'};
  ` }
`;

export const TitleProductStyle = styled.h1`
  ${typography.Headline1}
  color: ${basic.secondary};
  margin-top: 10px;
  text-transform: uppercase;
  ${ MediaStyle.md`
    ${typography.Display1};
    font-weight: 600;
  ` }
`;

export const PackageTitleStyle = styled.h3`
  margin-top: -15px;
  color: ${basic.secondary};
  ${typography.Subheader1};
  ${ MediaStyle.md`
    margin-top: -20px;
  ` }
`;

export const PriceStyle = styled.div`
  ${typography.Mega2};
  color: ${basic.secondary};
  margin-bottom: 25px;
  ${ MediaStyle.md`
    ${typography.Mega1};
  ` }
`;

export const FieldWrapperStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  ${ MediaStyle.lg`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-end;
  ` }
`;

export const SelectWrapperStyle = styled.div`
  & > div {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }
`;

export const FieldStyle = styled.div`
  margin-right: ${props => props.margin && "15px"}
`;

export const AvailabilityStyle = styled.div`
  border: 1px solid ${basic.greyGreen};
  border-left: none;
  white-space: nowrap;
  box-sizing: border-box;
  height: 32px;
  padding: 5px 5px 5px 30px;
  position: relative;
  margin: 15px 0 0 16px;
  display: inline-block;

  ${ MediaStyle.lg`
    display: block;
    margin: 0;
    width: 45%;
  `}
`;

export const IconWrapperStyle = styled.div`
  position: absolute;
  left: -15px;
  top: -2px;
`;

export const ButtonWrapperStyle = styled.div`
  padding: 25px 0 40px;
`;

export const LabelStyle = styled.label`
  display: block;
  ${typography.Caption1};
  ${props => props.bold && typography.Subheader1};
  ${props => props.bold && `text-transform: uppercase;`};
  span {
    font-size: 10px;
    display: inline-block;
    vertical-align: baseline;
  }
  strong {
    color: ${basic.secondary};
  }
`;

export const DescriptionStyle = styled.p`
  ${typography.Body2}
`;

export const SnackBarWrapperStyle = styled.div`
  margin-bottom: 30px;
`;

export const PackageProductsStyle = styled.div`
  & > article {
    margin-bottom: 15px;
  }
`;

export const PackageProductsTitleStyle = styled.h3`
  color: ${basic.secondary};
  border-bottom: 1px solid ${basic.secondary};
  ${typography.Subheader1};
  margin-bottom: 12px;
  padding-bottom: 5px;
`;


// WEBPACK FOOTER //
// ./src/components/productDetail/style.js